// JavaScript
import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {useSnackbar} from "notistack";
import sendRequest from "../services/sendRequest";
import './export.css';

const GetAssetIds = ({open, close, selectedRows}) => {
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const [loading, setLoading] = React.useState(false);

    if (!open) return null;

    const notify = (message, variant = 'default') => {
      const action = (key) => (
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
        >
          <CloseIcon/>
        </IconButton>
      );

      enqueueSnackbar(message, {
        variant,
        anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
        persist: true,
        action,
      });
    };

    const buildCsvFromResults = (results) => {
      const headers = ['asset_id', 'incorrect_custom_id', 'channel_id', 'correct_custom_id'];
      const quote = (v) => {
        if (v === null || v === undefined) return '';
        const s = String(v);
        return `"${s.replace(/"/g, '""')}"`;
      };

      const lines = [
        headers.join(','),
        ...results.map(r => `${quote(r.asset_id)},${quote(r.incorrect_custom_id)},${quote(r.channel_id)},${quote(r.correct_custom_id)}`)
      ];

      return lines.join('\n');
    };

    const downloadBlob = (content, filename = 'asset_ids.csv') => {
      const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', filename);
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    };

    const handleDownloadAndClose = async () => {
      if (!selectedRows || selectedRows.length === 0) {
        notify('Please select at least one row.', 'warning');
        return;
      }

      console.log('selectedRows', selectedRows)
      setLoading(true);

      try {
        const allResults = [];
        for (const row of selectedRows) {
          const payload = {
            channel_id: row.channel_id,
            custom_id: row.custom_id,
          };

          try {
            const response = await sendRequest({
              requestType: "post",
              endpoint: `customIdsPerChannel/getAssetIdsAndCustomIds/`,
              requestData: payload,
            });

            const data = response?.data ?? response;

            if (!Array.isArray(data?.results) || data.results.length === 0) {
              console.warn('No results for row:', row);
              continue;
            }

            const results = data.results.map(item => ({
              ...item,
              correct_custom_id: row.custom_id,
            }));
            allResults.push(...results);

            // const csv = buildCsvFromResults(results);
            //
            // // unique filename per row
            // const fileName = `${row.channel_id}_corrected_IDs.csv`;
            //
            // downloadBlob(csv, fileName);

          } catch (err) {
            console.error('Error for row:', row, err);
          }
        }
        if (allResults.length === 0) {
          notify('No data found to export.', 'warning');
          return;
        }

        // build ONE CSV from everything
        const csv = buildCsvFromResults(allResults);

        const fileName = `combined_corrected_IDs.csv`;
        downloadBlob(csv, fileName);

        notify('CSV file downloaded successfully!', 'success');
        close();

      } catch (err) {
        console.error('Download error:', err);
        notify('Failed to download CSV file(s).', 'error');
      } finally {
        setLoading(false);
      }


      // try {
      //   const payload = {
      //     channel_id: selectedRows[0].channel_id,
      //     custom_id: selectedRows[0].custom_id,
      //   };
      //
      //   const resp = await sendRequest({
      //     requestType: "post",
      //     endpoint: `customIdsPerChannel/getAssetIdsAndCustomIds/`,
      //     requestData: payload,
      //   });
      //
      //   const data = (resp && resp.data) ? resp.data : resp;
      //
      //   if (!data || !Array.isArray(data.results)) {
      //     notify('Unexpected response from server.', 'error');
      //     return;
      //   }
      //
      //   if (data.results.length > 1) {
      //     // Immutable approach: replace data.results with a new array
      //     data.results = data.results.map(item => ({ ...item, correct_custom_id: selectedRows[0].custom_id }));
      //
      //   }
      //
      //   if (data.results.length === 0) {
      //     notify('No results to download.', 'warning');
      //     return;
      //   }
      //
      //   const csv = buildCsvFromResults(data.results);
      //   downloadBlob(csv, 'asset_ids_and_incorrect_custom_ids.csv');
      //   notify('The .CSV file downloaded successfully!', 'success');
      //   close();
      // } catch (err) {
      //   console.error('Download error:', err);
      //   notify('Failed to download CSV file.', 'error');
      // } finally {
      //   setLoading(false);
      // }
    };

    const handleClose = () => {
      if (!loading) close();
    };

    return (
      <>
        <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <>
              <DialogContentText
                sx={{
                  textAlign: 'center',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  mb: 2,
                }}
              >
                Are you sure you want to download all asset IDs and incorrect custom ids associated with this/these
                channel as a .csv file?
              </DialogContentText>

              <DialogActions sx={{justifyContent: 'center'}}>
                <Button
                  onClick={handleDownloadAndClose}
                  className="csv-link"
                  variant="contained"
                  disabled={loading}
                >
                  {loading ? 'Downloading...' : 'Yes, Download'}
                </Button>
              </DialogActions>

              <DialogActions>
                <Button onClick={handleClose} className="dialog-close-button" disabled={loading}>
                  Close
                </Button>
              </DialogActions>
            </>

            {/*{selectedRows && selectedRows.length === 1 ? (*/}
            {/*  <>*/}
            {/*    <DialogContentText*/}
            {/*      sx={{*/}
            {/*        textAlign: 'center',*/}
            {/*        whiteSpace: 'normal',*/}
            {/*        wordWrap: 'break-word',*/}
            {/*        mb: 2,*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      Are you sure you want to download all asset IDs and incorrect custom ids associated with this channel as a .csv file?*/}
            {/*    </DialogContentText>*/}

            {/*    <DialogActions sx={{ justifyContent: 'center' }}>*/}
            {/*      <Button*/}
            {/*        onClick={handleDownloadAndClose}*/}
            {/*        className="csv-link"*/}
            {/*        variant="contained"*/}
            {/*        disabled={loading}*/}
            {/*      >*/}
            {/*        {loading ? 'Downloading...' : 'Yes, Download'}*/}
            {/*      </Button>*/}
            {/*    </DialogActions>*/}

            {/*    <DialogActions>*/}
            {/*      <Button onClick={handleClose} className="dialog-close-button" disabled={loading}>*/}
            {/*        Close*/}
            {/*      </Button>*/}
            {/*    </DialogActions>*/}
            {/*  </>*/}
            {/*) : (*/}
            {/*  <>*/}
            {/*    <DialogContentText*/}
            {/*      sx={{*/}
            {/*        textAlign: 'center',*/}
            {/*        color: 'warning.main',*/}
            {/*        whiteSpace: 'normal',*/}
            {/*        wordWrap: 'break-word',*/}
            {/*        mb: 2,*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      Please select only one row.*/}
            {/*    </DialogContentText>*/}

            {/*    <DialogActions sx={{ justifyContent: 'center' }}>*/}
            {/*      <Button onClick={handleClose} className="dialog-close-button" disabled={loading}>*/}
            {/*        Close*/}
            {/*      </Button>*/}
            {/*    </DialogActions>*/}
            {/*  </>*/}
            {/*)}*/}
          </DialogContent>
        </Dialog>

        <Backdrop
          sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
          open={loading}
        >
          <CircularProgress color="inherit"/>
        </Backdrop>
      </>
    );
  }
;

export default GetAssetIds;
